export default {
  landingTopFilterTitle: {
    id: 'landing_top_filter_title',
    defaultMessage: 'I need a phone that works with ...',
  },
  landingTopFilterLockPlaceholder: {
    id: 'landing_top_filter_lock_placeholder',
    defaultMessage: 'Locked or Unlocked',
  },
}
